import { marked } from "marked";
import { convertMultipleNewlinesToBR } from "../exports/functions";

const PrivacyPolicyInner = (props) => {
  const { policiesData } = props;
  const rawDescription = policiesData[0]?.attributes?.Description || "";
  const description = convertMultipleNewlinesToBR(rawDescription);

  return ( 
    <section className="privacy-policy pt-120" id="policies">
      <div className="container">
        <div className="row gy-4">
          <div className="col-lg-12">
            <div className="border border-neutral-30 rounded-12 bg-main-25 p-32 bg-main-25">
              <h3 className="mb-16">{policiesData[0]?.attributes?.Title}</h3>
              <span className="d-block border border-neutral-30 my-24 border-dashed" />
              <div className="d-flex align-items-center justify-content-between gap-24">
                <div className="d-flex align-items-center gap-16">
                  <div
                    className="text-neutral-500"
                    dangerouslySetInnerHTML={{
                      __html: marked(description),
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicyInner;
